export default __webpack_public_path__ + "static/media/portada.b5863be0.png";